import { Recipe } from "@/domains/recipes/RecipeSchema";
import { sortRecipesByPriority } from "@/domains/recipes/RecipePriority";

export interface MealDistributionInput {
  recipes: Recipe[];
  totalMeals: number;
}

export interface MealDistributionResult {
  mealsPerRecipe: Record<string, number>;
}

export function computeMealDistribution(
  input: MealDistributionInput
): MealDistributionResult {
  const { recipes, totalMeals } = input;

  const sorted = sortRecipesByPriority(recipes);

  const base = Math.floor(totalMeals / recipes.length);
  let remaining = totalMeals - base * recipes.length;

  const mealsPerRecipe: Record<string, number> = {};

  for (const recipe of sorted) {
    mealsPerRecipe[recipe.id] = base;
  }

  for (const recipe of sorted) {
    if (remaining <= 0) break;
    mealsPerRecipe[recipe.id] += 1;
    remaining -= 1;
  }

  return { mealsPerRecipe };
}
